
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiKeepingTrack as ObiKeepingTrackElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-keeping-track.js';
 
 
 

 
 export const ObiKeepingTrack = createComponent({
   react: React,
   tagName: 'obi-keeping-track',
   elementClass: ObiKeepingTrackElement,
   events: {
     
   }
  });
 
 